import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mt-25" }
const _hoisted_5 = { class: "row mb-3" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "table" }
const _hoisted_11 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-black fw-semibold" }, "Historique des prix du produit", -1)),
        _createVNode(_component_router_link, {
          to: { name: 'ListeProduit' },
          class: "btn btn-primary transition border-0 lh-1 fw-medium",
          style: {"position":"absolute","right":"10px","top":"10px"}
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1" }, null, -1),
            _createTextVNode(" Retour ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "produitFilter",
              class: "form-label"
            }, "Produit", -1)),
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.selectedProduit,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProduit) = $event)),
              options: [{ value: _ctx.produit?.id, label: _ctx.produit?.nomProd || 'N/A' }],
              searchable: false,
              disabled: true,
              "track-by": "value",
              label: "label",
              placeholder: "Produit"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "conditionnementFilter",
              class: "form-label"
            }, "Conditionnement", -1)),
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.selectedConditionnement,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedConditionnement) = $event)),
              options: _ctx.conditionnementOptions,
              searchable: true,
              "track-by": "value",
              label: "label",
              placeholder: "Tous les conditionnements"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "categorieClientFilter",
              class: "form-label"
            }, "Catégorie Client", -1)),
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.selectedCategorieClient,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCategorieClient) = $event)),
              options: _ctx.categorieClientOptions,
              searchable: true,
              "track-by": "value",
              label: "label",
              placeholder: "Toutes les catégories"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              for: "pointVenteFilter",
              class: "form-label"
            }, "Point de vente", -1)),
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.selectedPointVente,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedPointVente) = $event)),
              options: _ctx.pointVenteOptions,
              searchable: true,
              "can-clear": true,
              "can-deselect": true,
              "track-by": "value",
              label: "label",
              placeholder: "Tous les points de vente"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("table", _hoisted_10, [
          _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Date de définition"),
              _createElementVNode("th", null, "Point de vente"),
              _createElementVNode("th", null, "Conditionnement"),
              _createElementVNode("th", null, "Catégorie Client"),
              _createElementVNode("th", null, "Prix"),
              _createElementVNode("th", null, "Statut")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPrixHistorique, (prix, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(prix.createdAt) || 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(prix.pointvente?.nomPointVente || 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(prix.produitConditionnement?.conditionnement?.libelle || 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(prix.categorieClient?.libelle || 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(prix.prix || 'N/A'), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", prix.statut === true ? 'bg-success' : 'bg-danger'])
                  }, _toDisplayString(prix.statut === true ? 'Actif' : 'Inactif'), 3)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_PaginationComponent, {
        page: _ctx.page,
        totalPages: _ctx.totalPages,
        totalElements: _ctx.totalElements,
        limit: _ctx.limit,
        onPaginate: _ctx.handlePaginate
      }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
    ])
  ]))
}